import React, {ReactNode} from 'react'
import styled from 'styled-components'
import {Box} from '@mui/material'
import {ApplyTitle, FirstPageDiv, HeaderArea, HeaderAreaBox} from './NatAdminApplicatioPrintCommonStyle'
import {StyledDiv} from '../../../../../../styledComponents/StyledTypeDefinitions'
import {NatSealField, SealField} from './NatSealField'
import {NatEncloseInParenthesis} from './NatEncloseInParenthesis'
import moment from 'moment'
import {
    APPLY_IRREGULAR_PATTERN,
    PET_TYPE,
    RESIDENT_APPLY_PROCESS,
    RESIDENT_APPLY_STATUS
} from '../../../../../../CodeMaster'
import {ApplyStatusInfo} from '../../../repository/NatGetApplicationStatus'
import {convertToRoomNumberForResident} from '../../../../../common/util/Natutil'
import {NatPetMedicalCheckUpReportDetail} from '../../../repository/NatGetPetMedicalCheckUpReport'

interface Props {
    petMedicalCheckUpReportApplicationDocumentParam: NatPetMedicalCheckUpReportDetail
    applyStatusInfoList: ApplyStatusInfo[]
}

export const NatPetMedicalCheckUpReportApplicationDocument: React.FC<Props> = props => {
    const {
        petMedicalCheckUpReportApplicationDocumentParam,
        applyStatusInfoList,
    } = props

    const {
        applyId, condominiumName, ridgeName, roomNumber,
        applicantFamilyName, applicantFirstName, petType, petBreed,
    } = petMedicalCheckUpReportApplicationDocumentParam

    const applicantRoom = `${ridgeName} ${convertToRoomNumberForResident(roomNumber)}`
    const applicantName = `${applicantFamilyName} ${applicantFirstName}`
    const petTypeLabel = `${PET_TYPE.codeToEnumConstants(petType).label}`

    return (<>
        <FirstPageDiv>
            <HeaderArea>
                <HeaderAreaBox>
                    <Box ml={'auto'} mt={'10mm'}>申請ID：{applyId}</Box>
                </HeaderAreaBox>
                <HeaderAreaBox>
                    <Box m={'auto'}><ApplyTitle>健康診断報告書</ApplyTitle></Box>
                </HeaderAreaBox>
                <HeaderAreaBox>
                    <Box ml={'auto'} mt={'3mm'}>
                        {renderSealField(applyStatusInfoList)}
                    </Box>
                </HeaderAreaBox>
            </HeaderArea>
            <Box ml={'25mm'} mt={'3mm'}>
                理事長殿
            </Box>
            <Box ml={'30mm'} mt={'5mm'} whiteSpace={'pre-wrap'}>
                　私は、登録、狂犬病予防注射及び健康診断を行ったので、次のとおり報告をいたします。
            </Box>
            <Box margin={'3mm 0 0 30mm'} display={'flex'} flexDirection={'column'} width={'130mm'}>
                <Box>
                    <Box mb={'5mm'} whiteSpace={'pre-wrap'}>1  申請者</Box>
                    <Box ml={'8mm'} mb={'5mm'}>
                        {renderApplicationDetail('マンション名', condominiumName)}
                        {renderApplicationDetail('部屋番号', applicantRoom)}
                        {renderApplicationDetail('氏名', applicantName)}
                    </Box>
                </Box>
                <Box mb={'5mm'}>
                    <Box mb={'5mm'} whiteSpace={'pre-wrap'}>2  飼育するペット</Box>
                    <Box ml={'8mm'}>
                        {renderApplicationDetail('種類', petTypeLabel)}
                        {renderApplicationDetail('犬種等', petBreed)}
                    </Box>
                </Box>
            </Box>
        </FirstPageDiv>
    </>)

    NatPetMedicalCheckUpReportApplicationDocument.displayName = 'NatPetMedicalCheckUpReportApplicationDocument'
}

const renderApplicationDetail = (title: string, value: string | ReactNode) => {
    return (
        <PrintApplicationDetailContainer>
            <Box whiteSpace={'pre-wrap'}>{title}</Box>
            <NatEncloseInParenthesis item={value}/>
        </PrintApplicationDetailContainer>
    )
}

const renderSealField = (applyStatusInfoList: ApplyStatusInfo[]) => {
    const sealFields: SealField[] = applyStatusInfoList.map((info) => {
        const applyStatusEnum = RESIDENT_APPLY_PROCESS.codeToEnumConstants(info.applyProcess)
        let seal
        if (info.applyStatus === RESIDENT_APPLY_STATUS.REJECTION.value) {
            seal = '却下'
        } else if (info.actual.irregularPattern === APPLY_IRREGULAR_PATTERN.NO_PET_CLUB.value) {
            seal = '-'
        } else {
            seal = info.actual.registerDatetime ? moment(info.actual.registerDatetime).format('YYYY/M/D') : ''
        }
        return {
            applyStatus: applyStatusEnum.label,
            seal: seal,
            sortOrder: applyStatusEnum.displayOrder
        }
    });

    return (
        <NatSealField sealFields={sealFields}/>
    )
}

const PrintApplicationDetailContainer: StyledDiv = styled.div`
  display: flex;
  width: 100%;
`
